import { Routes } from '@angular/router';
import { SignupOtpComponent } from './signup-otp/signup-otp.component';
import { SignupPhoneComponent } from './signup-phone/signup-phone.component';
import { SignupFormComponent } from './signup-form/signup-form.component';
import { SignupWarningComponent } from './signup-warning/signup-warning.component';
import { SignupCardComponent } from './signup-card/signup-card.component';

export const signupRoutes: Routes = [
  {
    path: '',
    redirectTo: '/result/page-not-found',
    pathMatch: 'full'
  },
  {
    path: 'phone-number-check/:trackingId',
    component: SignupPhoneComponent
  },
  {
    path: 'otp/:trackingId',
    component: SignupOtpComponent
  },
  {
    path: 'form/:trackingId',
    component: SignupFormComponent
  },
  {
    path: 'warning',
    component: SignupWarningComponent
  },
  {
    path: 'card/:trackingId',
    component: SignupCardComponent
  },
  {
    path: '**',
    redirectTo: '/result/page-not-found',
    pathMatch: 'full'
  }
];
